import { faInfoCircle, faCircleArrowRight, IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { CaraUser, CaraUserService, ThemeService } from "center-services";
import { SubscriptionService } from "fugu-common";

@Component({
  selector: "app-release-popup",
  templateUrl: "./release-popup.component.html",
  styleUrls: ["./release-popup.component.scss"],
  providers: [SubscriptionService],
})
export class ReleasePopupComponent implements OnInit {
  @Output() closePopupEvent: EventEmitter<any> = new EventEmitter();

  public popupVisible: boolean = true;
  public imageLink: string = "";
  public btnIcon: IconDefinition = faCircleArrowRight;
  public faInfoCircle: IconDefinition = faInfoCircle;

  constructor(
    private userService: CaraUserService,
    private themeService: ThemeService,
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit(): void {
    if (this.userService.connectedUser.value) {
      this.setImageLink(this.userService.connectedUser.value.codeLanguage);
    } else {
      this.fetchConnectedUser();
    }
  }

  public closePopup(): void {
    this.popupVisible = false;
    this.closePopupEvent.emit();
  }

  public openReleaseNotes(): void {
    window.open("https://monfugu.fr/notes-de-mise-a-jour-center/");
  }

  private fetchConnectedUser(): void {
    this.subscriptionService.subs.push(
      this.userService.connectedUser.subscribe((connectedUser: CaraUser) => {
        if (connectedUser) {
          this.setImageLink(connectedUser.codeLanguage);
        }
      })
    );
  }

  private setImageLink(languageCode: string): void {
    const darkTheme = this.themeService.getValue() ? "light" : "dark";
    this.imageLink = `./assets/images/help_menu_${darkTheme}_${languageCode.toUpperCase()}.png`;
  }
}
